"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseAllRateLimited = promiseAllRateLimited;
const p_limit_1 = __importDefault(require("p-limit"));
/**
 * Promise.all with rate limit
 */
function promiseAllRateLimited(promises, rateLimit) {
    const limit = (0, p_limit_1.default)(rateLimit);
    return Promise.all(promises.map((p) => limit(p)));
}
//# sourceMappingURL=promise-all-rate-limited.js.map